import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { ManageFamilyMembersPage } from '../manage-family-members/manage-family-members.page';
import { SelectComponent as TagsSelectPage } from 'src/app/components/tags/select/select.component';
import { ManagerComponent as GroupsManagerPage } from 'src/app/components/groups/manager/manager.component';
import { SelectPage as TeamMembersSelectPage } from 'src/app/team-members/select/select.page';
import * as dayjs from 'dayjs';
import { GlobalService } from 'src/app/api/global.service';

import { Calendar, CalendarOptions } from '@fullcalendar/core';
import { FullCalendarComponent } from '@fullcalendar/angular';


import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { CompaniesContactsSelectPage as ContactsSelectPage } from 'src/app/modals/companies-contacts-select/companies-contacts-select.page';
import { ProjectsService } from 'src/app/api/projects.service';
import { DetailsPage as ProjectDetailsPage } from 'src/app/projects/details/details.page';
import { DetailsPage as TaskDetailsPage } from 'src/app/tasks/details/details.page';
import { DetailsPage as StepDetailsPage } from 'src/app/steps/details/details.page';
import { DetailsPage as EmailDetailsPage } from 'src/app/secure-email/details/details.page';
import { CustomFieldsService, CustomFieldDef } from 'src/app/api/custom-fields.service';
import { ManageComponent as ManageCustomFieldsComponent } from 'src/app/components/custom-fields/manage/manage.component';



@Component({
  selector: 'app-details',
  templateUrl: './details.page.html',
  styleUrls: ['./details.page.scss'],
})
export class DetailsPage implements OnInit {

  languageOptions: any = null;


  calendarOptions: CalendarOptions;
  @ViewChild('tmcalendar') calendarComponent: FullCalendarComponent;
  public calendarAPI: Calendar = null;
  events = {
    message: 'Got Data',
    success: '1',
    status_code: 200,
    data: []
  }
  LoadedCalendar = false;


  data: any = null;
  client_data: any;
  // Current firm-wide contact field definitions (Manage Firm > Contacts), refreshed by
  // MergeFirmCustomFields() - used by IsGlobalField() to lock the type dropdown on a field that
  // came from (or now matches) the global list, since letting one contact retype it would
  // disagree with what every other contact/dynamic-data consumer expects that field to be.
  firmFieldDefs: CustomFieldDef[] = [];

  activeIndex = 'overview';
  // Opened from an @mention notification: the comment to scroll to and highlight on the Comments tab
  @Input() focus_comment: any = null;
  // Opens the details on this tab (e.g. 'todos' from the To Do list's client link)
  @Input() start_tab = '';
  todo_status: 'open' | 'completed' | 'all' = 'open';
  detailsIndex = 'name';

  @Input() client = {
    guid: '',
    display_name: '',
    description: '',
    phone_number: '',
    fax: '',
    website: '',
    str_address: '',
    str_address_2: '',
    city: '',
    province: '',
    postal_code: '',
    country: '',
    tags: [],
    team_members: [],
    comments: [],
    files: [],
    projects: [],
    groups: [],
    custom1: '',
    custom2: '',
    custom3: '',
    custom4: '',
    custom5: '',
    notes: '',
    folder: [],
    family_members: [],
    alt_province: '',
    alt_postal_code: '',
    alt_countr: '',
    alt_address_name: '',
    alt_address: '',
    alt_city: '',
    alt_country: '',
    main_phone: '',
    alt_phone: '',
    cell_phone: '',
    pager: '',
    email: '',
    facebook: '',
    twitter: '',
    gender: '',
    birthday: '',
    anniversary: '',
    sin: '',
    spoken_language: '',
    spoken_language_arr: [],
    children: '',
    home_address: '',
    name_suffix: '',
    first_name: '',
    last_name: '',
    email_re: '',
    authentication_phone_number: '',
    title: '',
    middle_name: '',
    custom_id: '',
    custom_data: '',
    custom_data_arr: [],
    is_a_client: true,
    username: '',
    active: false,
    all_team_members: false,
    year_end_month: '',
    year_end_day: '',
    year_end_date: '',
    deleted: false,

  }

  // One edit mode for the whole contact (the Edit in the footer): Overview and Details are edited together
  edit_mode = false;
  details_edit_mode = false;
  // True while editing (the template shows the validation message with it)
  get editing_section(): boolean { return this.edit_mode; }

  StartEdit() {
    if (!this.globalService.Can('contacts_update')) return;
    this.edit_mode = true;
    this.details_edit_mode = true;
  }

  // Asks before leaving (another tab, or closing) while editing - leaving undoes the changes that aren't saved yet
  private async ConfirmDiscardEdits(): Promise<boolean> {
    if (!this.edit_mode && !this.details_edit_mode) return true;
    return new Promise<boolean>(async resolve => {
      const alert = await this.alertController.create({
        header: 'Unsaved Changes',
        message: 'You are editing this contact. Leaving will undo your changes until you click Save.',
        backdropDismiss: false,
        buttons: [
          { text: 'Discard Changes', role: 'destructive', handler: () => resolve(true) },
          { text: 'Keep Editing', role: 'cancel', handler: () => resolve(false) }
        ]
      });
      await alert.present();
    });
  }

  client_basic_info: any = {};
  comment_filter: string = 'Contact';
  all_client_comments: any[] = [];
  client_direct_comments: any[] = [];
  client_project_comments: any[] = [];
  client_task_comments: any[] = [];
  client_step_comments: any[] = [];
  client_missing_info_comments: any[] = [];
  client_secure_email_comments: any[] = [];
  comments_loading: boolean = false;
  active_reply_guid: string = null;
  reply_comment: any = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };
  total_comment_count: number = 0;

  unassigned_team_members = [];
  add_tag = {
    text: '',
    colour: '#90ee90'
  }
  team_member_roles = [];


  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService, private projectsService: ProjectsService, private alertController: AlertController, private customFieldsService: CustomFieldsService) {


  }

  ngOnInit() {
    if (this.start_tab) this.activeIndex = this.start_tab;
    this.GetExtraData();
    this.GetData();
  }

  async ChangeAllowAllTeamMembers() {
    console.log("Change Allow All Team Members, ", this.client.all_team_members);
    let post_data = {
      all_team_members: this.client.all_team_members
    }
    let data: any = await this.apiService.put(`clients/${this.client.guid}`, post_data);
  }

  async GetExtraData() {
    this.languageOptions = await this.apiService.getSpecificURL('https://app.fusionworkflow.com/assets/files/Languages.json');
  }


  //ORDER IS IMPORTANT
  async GetData() {
    await this.globalService.presentLoading("", 9000000);
    await this.GetRoles();
    this.GetDetails();
    this.globalService.dismissLoading();
  }
  async GetRoles() {
    await this.GetTeamRoles();
  }

  //Return the list of team member roles
  async GetTeamRoles() {
    let data: any = await this.apiService.get('firms/team_members/roles');
    if (data.success) {
      this.team_member_roles = data.data;
    }
  }

  async GetDetails() {
    let data: any = await this.apiService.get(`clients/${this.client.guid}`);
    if (data.success) {
      this.client = data.data[0];

      //make the object cleaner
      if (!this.client.team_members) this.client.team_members = [];
      if (!this.client.tags) this.client.tags = [];
      if (!this.client.comments) this.client.comments = [];
      if (!this.client.files) this.client.files = [];
      if (!this.client.projects) this.client.projects = [];
      if (!this.client.groups) this.client.groups = [];
      if (!this.client.family_members) this.client.family_members = [];
      this.GetAssociatedCompanies();


      if (this.client.birthday) this.client.birthday = dayjs(this.client.birthday).format('YYYY-MM-DD');
      if (this.client.anniversary) this.client.anniversary = dayjs(this.client.anniversary).format('YYYY-MM-DD');

      {
        let parsed: any = this.client.custom_data;
        // Handles plain strings, double-encoded strings, and already-parsed values
        for (let i = 0; i < 2 && typeof parsed === 'string' && parsed; i++) {
          try { parsed = JSON.parse(parsed); } catch (e) { parsed = []; }
        }
        this.client.custom_data_arr = Array.isArray(parsed) ? parsed : [];
      }
      await this.MergeFirmCustomFields();

      if (this.client.spoken_language && typeof this.client.spoken_language === 'string') {
        this.client.spoken_language_arr = this.client.spoken_language
          .split('~')
          .filter(lang => lang.trim() !== '')
          .map(lang => ({ label: lang, value: lang }));
      } else {
        this.client.spoken_language_arr = [];
      }

      console.log("~~");
      console.log("CLIENT:", this.client.projects);
      //Make a copy of the company for editing basic info
      this.client_basic_info = this.globalService.CopyBasicInfo(this.client);
      // Snapshot the MERGED array (post-MergeFirmCustomFields), not the raw pre-merge
      // this.client.custom_data string - CancelUpdate() reads client_basic_info.custom_data (not
      // .custom_data_arr, which is what was being written here) to restore custom_data_arr on
      // Cancel, so this also fixes clicking Cancel wiping the merged-in firm-wide fields.
      this.client_basic_info.custom_data = JSON.stringify(this.client.custom_data_arr);
      if (this.activeIndex === 'comments') this.GetAllClientComments();
    }
  }



  async GoToStep(step) {
    if (step !== this.activeIndex) {
      if (!(await this.ConfirmDiscardEdits())) return;
      if (this.edit_mode || this.details_edit_mode) await this.CancelUpdate();
    }
    this.activeIndex = step;
    if (step == 'comments') {
      this.GetAllClientComments();
    }
    else if (step == "calendar") {
      if (!this.LoadedCalendar) this.DrawCalendar();
    }
  }

  async GetAllClientComments() {
    this.comments_loading = true;

    this.client_direct_comments = [];
    this.client_project_comments = [];
    this.client_task_comments = [];
    this.client_step_comments = [];
    this.client_missing_info_comments = [];
    this.client_secure_email_comments = [];

    const result: any = await this.apiService.get(`clients/${this.client.guid}/all_comments`);
    if (result.success && result.data) {
      const formatComment = (c: any) => {
        const f = { ...c };
        if (f.users && typeof f.users === 'string') f.users = JSON.parse(f.users);
        return f;
      };
      for (const c of result.data.map(formatComment)) {
        if (c.source_type === 'client') this.client_direct_comments.push(c);
        else if (c.source_type === 'project') this.client_project_comments.push(c);
        else if (c.source_type === 'task') this.client_task_comments.push(c);
        else if (c.source_type === 'step') this.client_step_comments.push(c);
        else if (c.source_type === 'missing_info') this.client_missing_info_comments.push(c);
        else if (c.source_type === 'secure_email') this.client_secure_email_comments.push(c);
      }
      this.client.comments = [...this.client_direct_comments];
    }

    this.all_client_comments = [
      ...this.client_direct_comments,
      ...this.client_project_comments,
      ...this.client_task_comments,
      ...this.client_step_comments,
      ...this.client_missing_info_comments,
      ...this.client_secure_email_comments,
    ];
    this.total_comment_count = this.all_client_comments.length;
    this.comments_loading = false;
  }

  async OpenCommentSource(comment: any) {
    const componentMap: any = {
      project: ProjectDetailsPage,
      task: TaskDetailsPage,
      step: StepDetailsPage,
      secure_email: EmailDetailsPage,
    };
    const component = componentMap[comment.source_type];
    if (!component) return;
    const modal = await this.modalController.create({
      component,
      cssClass: 'large-modal',
      componentProps: { guid: comment.source_guid },
      backdropDismiss: false,
    });
    await modal.present();
  }

  GetFilteredClientComments() {
    if (this.comment_filter === 'Project') return this.client_project_comments;
    if (this.comment_filter === 'Task') return this.client_task_comments;
    if (this.comment_filter === 'Actions') return this.client_step_comments;
    if (this.comment_filter === 'Missing Information') return this.client_missing_info_comments;
    if (this.comment_filter === 'Secure Email') return this.client_secure_email_comments;
    return this.all_client_comments;
  }

  SetClientCommentFilter(filter: string) {
    this.comment_filter = filter;
    this.CancelInlineReply();
  }

  StartInlineReply(comment: any) {
    this.active_reply_guid = comment.guid;
    this.reply_comment = {
      reply_to: comment.guid,
      reply_to_text: comment.comment,
      reply_to_name: comment.users?.[0]?.display_name,
      comment: '',
      update: false
    };
  }

  CancelInlineReply() {
    this.active_reply_guid = null;
    this.reply_comment = { reply_to: null, reply_to_text: null, reply_to_name: null, comment: '', update: false };
  }

  async SubmitInlineReply(comment: any) {
    let url = 'client/comments';
    let guid = this.client.guid;
    if (comment.source_type === 'project') { url = 'projects/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'task') { url = 'tasks/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'step') { url = 'steps/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'missing_info') { url = 'missing_info/comments'; guid = comment.source_guid; }
    else if (comment.source_type === 'secure_email') { url = 'secure_email/comments'; guid = comment.source_guid; }

    const data: any = await this.apiService.post(`${url}/${guid}`, this.reply_comment);
    if (data.success) {
      const current_user = this.globalService.GetCurrentUser();
      const new_comment: any = data.data[0];
      new_comment.users = [{ display_name: current_user.display_name, guid: current_user.guid }];
      new_comment.comment = JSON.parse(JSON.stringify(this.reply_comment.comment));
      new_comment.reply_to_guid = this.reply_comment.reply_to;
      new_comment.source_type = comment.source_type;
      new_comment.source_title = comment.source_title;
      new_comment.source_guid = comment.source_guid;

      if (comment.source_type === 'project') this.client_project_comments.unshift(new_comment);
      else if (comment.source_type === 'task') this.client_task_comments.unshift(new_comment);
      else if (comment.source_type === 'step') this.client_step_comments.unshift(new_comment);
      else if (comment.source_type === 'missing_info') this.client_missing_info_comments.unshift(new_comment);
      else if (comment.source_type === 'secure_email') this.client_secure_email_comments.unshift(new_comment);
      else { this.client_direct_comments.unshift(new_comment); if (this.client.comments) this.client.comments.unshift(new_comment); }

      this.all_client_comments.unshift(new_comment);
      this.total_comment_count = this.all_client_comments.length;
      this.CancelInlineReply();
    }
    this.globalService.presentToastMessage(data.message, data.success);
  }

  @ViewChild('commentsTable') commentsTable: any;
  @ViewChild('topRowRef', { static: false }) topRowRef: ElementRef | undefined;
  @ViewChild('footerRowRef', { static: false }) footerRowRef: ElementRef | undefined;
  @ViewChild('navRowRef', { static: false }) navRowRef: ElementRef | undefined;
  GetCommentsSize() {
    const el = this.topRowRef.nativeElement as HTMLElement;
    const rect = el.getBoundingClientRect();
    const footerEl = this.footerRowRef.nativeElement as HTMLElement;
    const footerRect = footerEl.getBoundingClientRect();
    const navEl = this.navRowRef.nativeElement as HTMLElement;
    const navRect = navEl.getBoundingClientRect();
    let allowed_size = Math.round(rect.height) - (Math.round(footerRect.height) + Math.round(navRect.height));
    console.log("Allowed Size:", allowed_size);
    return allowed_size - 1;
  }



  GoToStepDetails(step) {
    this.detailsIndex = step;
  }

  async Close() {
    if (!(await this.ConfirmDiscardEdits())) return;
    if (this.edit_mode || this.details_edit_mode) await this.CancelUpdate();
    this.modalController.dismiss(this.client);
  }

  async OpenManageFamilyMembersModal() {
    const modal = await this.modalController.create({
      component: ManageFamilyMembersPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        client: this.client
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data.data) {
        this.data.push(data.data);
      }
    });
    return await modal.present()
  }

  //When they are trying to update the basic information about the company
  async CancelUpdate() {
    this.edit_mode = false;
    this.details_edit_mode = false;
    this.globalService.RestoreBasicInfo(this.client_basic_info, this.client);
    try {
      const restored = JSON.parse(this.client_basic_info.custom_data);
      this.client.custom_data_arr = Array.isArray(restored) ? restored : [];
    } catch (e) {
      this.client.custom_data_arr = [];
    }
  }

  async UpdateBasicInfo() {
    // Asks about any field added via addField() this edit session, before saving - see
    // CustomFieldsService.PromptAndSaveNewFieldScopes. Runs before the loading overlay so its
    // alert doesn't stack on top of it.
    if (!Array.isArray(this.client.custom_data_arr)) this.client.custom_data_arr = [];
    this.firmFieldDefs = await this.customFieldsService.PromptAndSaveNewFieldScopes('contacts', this.client.custom_data_arr);
    await this.globalService.presentLoading("Updating Client...", 9000000);
    this.client.spoken_language = this.client.spoken_language = this.client.spoken_language_arr.map(lang => typeof lang === 'string' ? lang : lang.name || lang.value || '').join('~');
    this.customFieldsService.AssignFieldIds(this.client.custom_data_arr);
    this.client.custom_data = JSON.stringify(this.client.custom_data_arr);
    let data: any = await this.apiService.put(`clients/${this.client.guid}`, this.client);
    this.globalService.presentToastMessage(data.message, data.success);
    if (data.success) {
      this.client_basic_info = this.globalService.CopyBasicInfo(this.client);
      this.client_basic_info.custom_data = this.client.custom_data;
      this.edit_mode = false;
      this.details_edit_mode = false;

      if (this.client.spoken_language && typeof this.client.spoken_language === 'string') {
        this.client.spoken_language_arr = this.client.spoken_language
          .split('~')
          .filter(lang => lang.trim() !== '')
          .map(lang => ({ label: lang, value: lang }));
      } else {
        this.client.spoken_language_arr = [];
      }
    }
    this.globalService.dismissLoading();

  }



  //TAGS
  //Present the modal to select tags to apply to the company
  async presentSelectTagsModal() {
    let client_tags_copy = JSON.stringify(this.client.tags);
    const modal = await this.modalController.create({
      component: TagsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'clients',
        client: this.client,
        selected_tags: this.client.tags
      }
    })
    modal.onDidDismiss().then((data: any) => {

      if (data && data.data) {
        client_tags_copy = JSON.parse(client_tags_copy);
        this.CheckClientTags(client_tags_copy, data.data);
      }
      else {
        this.client.tags = [...JSON.parse(client_tags_copy)];
      }
    });
    return await modal.present()
  }

  //See if we have to remove or add tags
  async CheckClientTags(old_tags, new_tags) {
    await this.globalService.presentLoading("Updating Tags...", 9000000);
    //Check to see if all the old tags still exist, if not we will run a delete statement to the api
    old_tags.forEach(tag => {
      const index = new_tags.findIndex(e => tag.guid === e.guid);
      if (index == -1) {
        console.log(tag);
        this.RemoveTag(tag);
      }
    });
    //If the old tag does not exist in the new tags, run api statement to add it
    new_tags.forEach(tag => {
      const index = old_tags.findIndex(e => tag.guid === e.guid);
      if (index == -1) {
        this.AddTag(tag);
      }
    });
    this.globalService.dismissLoading();
  }
  async RemoveTag(tag) {
    let data: any = await this.apiService.delete(`clients/tags/${this.client.guid}`, tag);
  }
  async AddTag(tag) {
    let data: any = await this.apiService.post(`clients/tags/${this.client.guid}`, tag);
  }


  // GROUPS
  async presentSelectGroupsModal() {
    let client_groups_copy = JSON.stringify(this.client.groups);
    const modal = await this.modalController.create({
      component: GroupsManagerPage,
      cssClass: 'medium-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'clients',
        selection_mode: true,
        max_selection: 999,
        selected_groups: [...this.client.groups],
        modal_title: 'Select Groups'
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data) {
        client_groups_copy = JSON.parse(client_groups_copy);
        this.CheckClientGroups(client_groups_copy, data.data);
      }
    });
    return await modal.present();
  }

  //See if we have to remove or add groups
  async CheckClientGroups(old_groups, new_groups) {
    await this.globalService.presentLoading("Updating Groups...", 9000000);
    //Check to see if all the old groups still exist, if not we will run a delete statement to the api
    old_groups.forEach(group => {
      const index = new_groups.findIndex(e => group.guid === e.guid);
      if (index == -1) {
        console.log(group);
        this.RemoveGroup(group);
      }
    });
    //If the old group does not exist in the new groups, run api statement to add it
    new_groups.forEach(group => {
      const index = old_groups.findIndex(e => group.guid === e.guid);
      if (index == -1) {
        console.log("ADD");
        this.AddGroup(group);
      }
    });
    this.client.groups = [...new_groups];
    this.globalService.dismissLoading();
  }
  async RemoveGroup(group) {
    let data: any = await this.apiService.delete(`groups/clients/${this.client.guid}`, group);
  }
  async AddGroup(group) {
    let data: any = await this.apiService.post(`groups/clients/${this.client.guid}`, group);
  }

  //select team members and add them to the companies team members
  async presentSelectTeamMembersModal() {
    let client_team_members_copy = JSON.stringify(this.client.team_members);
    const modal = await this.modalController.create({
      component: TeamMembersSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        selecting_for_company: true,
        selected_team_members: this.client.team_members,
        remove_team_members: this.client.team_members,
        in_team_members: [],
        target_header: 'Currently Selected'
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data) {
        client_team_members_copy = JSON.parse(client_team_members_copy);
        this.CheckclientTeamMembers(client_team_members_copy, data.data);
      }
      else {
        this.client.team_members = [...JSON.parse(client_team_members_copy)];
      }

    });
    return await modal.present()
  }

  //See if we have to remove or add tags
  async CheckclientTeamMembers(old_team_members, new_team_members) {
    await this.globalService.presentLoading("Updating Team Members...", 9000000);
    //Check to see if all the old team_members still exist, if not we will run a delete statement to the api
    old_team_members.forEach(team_member => {
      const index = new_team_members.findIndex(e => team_member.guid === e.guid);
      if (index == -1) {
        this.RemoveTeamMember(team_member);
      }
    });
    //If the old client does not exist in the new team_members, run api statement to add it
    new_team_members.forEach(team_member => {
      const index = old_team_members.findIndex(e => team_member.guid === e.guid);
      if (index == -1) {
        this.AddTeamMember(team_member);
      }
    });
    //Loop through and see what clients have been changed
    new_team_members.forEach(team_member => {
      const index = old_team_members.findIndex(e => team_member.guid === e.guid);
      if (index >= 0) {
        if (JSON.stringify(team_member) != JSON.stringify(old_team_members[index])) {
          this.UpdateTeamMember(team_member)
        }
      }
    });
    this.globalService.dismissLoading();
  }

  async RemoveTeamMember(team_member) {
    let data: any = await this.apiService.delete(`clients/team_members/${this.client.guid}`, team_member);

  }
  async AddTeamMember(team_member) {
    let data: any = await this.apiService.post(`clients/team_members/${this.client.guid}`, team_member);
  }
  async UpdateTeamMember(team_member) {
    let data: any = await this.apiService.put(`clients/team_members/${this.client.guid}`, team_member);
  }

  GetEmployeeTypeText(guid) {
    let i = this.team_member_roles.findIndex(item => item.guid === guid);
    if (i == -1)
      return "No Role";
    else
      return this.team_member_roles[i].title;
  }

  GetEmployeeTypeColour(guid) {
    let i = this.team_member_roles.findIndex(item => item.guid === guid);
    if (i == -1)
      return "#ADD8E6";
    else
      return this.team_member_roles[i].colour;
  }

  async presentDetailsModal(_guid) {
    let pass_client = {
      guid: _guid
    }
    const modal = await this.modalController.create({
      component: DetailsPage,
      cssClass: 'large-modal',
      componentProps: {
        client: pass_client
      },
      backdropDismiss: false

    })
    modal.onDidDismiss().then((data: any) => {

    });
    return await modal.present()
  }

  skeleton: any[];

  formatPhoneNumber() {
    this.client.phone_number = this.globalService.FormatPhoneNumber(this.client.phone_number);
    this.client.alt_phone = this.globalService.FormatPhoneNumber(this.client.alt_phone);
    this.client.cell_phone = this.globalService.FormatPhoneNumber(this.client.cell_phone);
  }

  handleAddressChange(address: Address) {
    this.client.str_address = address.formatted_address;
    this.client.city = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['locality', 'political']))[0].long_name;
    this.client.province = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['administrative_area_level_1', 'political']))[0].long_name;
    this.client.country = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['country', 'political']))[0].long_name;
    this.client.postal_code = address.address_components.filter(f => JSON.stringify(f.types) === JSON.stringify(['postal_code']))[0].long_name;
  }

  //Calendar Logic
  async DrawCalendar() {
    //calendar settings
    this.calendarOptions = {
      initialView: 'dayGridMonth',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridDay,timeGridWeek'
      },
      events: this.events.data,
      plugins: [dayGridPlugin, timeGridPlugin],
      datesSet: () => {
        if (this.calendarAPI) {
          this.projectsService.ConvertToCalendar(this.calendarAPI.view.currentStart.toISOString(), this.calendarAPI.view.currentEnd.toISOString(), `&client=${this.client.guid}`, 'client', this.events, true, true, true);
        }
      }
    };

    setTimeout(() => {
      this.LoadedCalendar = true;
      this.calendarAPI = this.calendarComponent.getApi();

      this.projectsService.ConvertToCalendar(this.calendarAPI.view.currentStart.toISOString(), this.calendarAPI.view.currentEnd.toISOString(), `&client=${this.client.guid}`, 'client', this.events, true, true, true);
      window.dispatchEvent(new Event('resize'))

    }, 500)

  }

  async ChangeView(view) {
    this.calendarAPI.changeView(view);
  }

  // The companies this contact is linked to and their role in each (only companies this team member can see)
  associated_companies: any[] = [];
  associated_companies_loaded = false;
  async GetAssociatedCompanies() {
    const data: any = await this.apiService.get(`clients/${this.client.guid}/companies`);
    this.associated_companies = data?.success && Array.isArray(data.data) ? data.data : [];
    this.associated_companies_loaded = true;
  }

  async OpenCompanyDetails(company: any) {
    if (!company?.guid) return;
    // Loaded on demand: the company details page imports this one too
    const { DetailsPage: CompanyDetailsPage } = await import('src/app/companies/details/details.page');
    const modal = await this.modalController.create({
      component: CompanyDetailsPage,
      cssClass: 'large-modal',
      componentProps: { company: { guid: company.guid } },
      backdropDismiss: false,
    });
    return await modal.present();
  }

  async GetFamilyMembers() {
    let data: any = await this.apiService.get(`clients/family_members/${this.client.guid}`);
    if (data.success) this.client.family_members = data.data;
    if (!this.client.family_members) this.client.family_members = [];

  }

  //Family Members
  async presentSelectFamilyMembers() {
    let family_members_copy = JSON.stringify(this.client.family_members);
    console.log("Family Members: ", this.client.family_members);
    const modal = await this.modalController.create({
      component: ContactsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: false,
      componentProps: {
        selecting_for_family: true,
        selected_clients: this.client.family_members,
        remove_clients: this.client.family_members,
        in_clients: [],
        target_header: 'Currently Selected',
        modal_title: 'Select Family Members',
        hide_companies: true,
      },
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data.clients) {
        this.UpdateFamilyMembers(data.data.clients, family_members_copy);
      }


    });
    return await modal.present()
  }

  async UpdateFamilyMembers(new_family_members, family_members_copy) {
    let changed_somthing = false;
    const old_family_members = JSON.parse(family_members_copy);
    await this.globalService.presentLoading("Updating Family Members...", 9000000);
    // Remove or update existing family members
    for (let i = 0; i < old_family_members.length; i++) {
      const old_fm = old_family_members[i];
      const index = new_family_members.findIndex(e => old_fm.linked_guid === e.linked_guid);
      if (index == -1) {
        await this.RemoveFamilyMember(old_fm);
        changed_somthing = true;
      } else {
        if (JSON.stringify(old_fm) != JSON.stringify(new_family_members[index])) {
          await this.AddFamilyMember(new_family_members[index]);
          changed_somthing = true;
        }
      }
    }

    // Add new family members or update relationship if changed
    for (let i = 0; i < new_family_members.length; i++) {
      const new_fm = new_family_members[i];
      const index = old_family_members.findIndex(e => new_fm.linked_guid === e.linked_guid);
      if (index == -1) {
        await this.AddFamilyMember(new_fm);
        changed_somthing = true;
      } else {
        if (new_fm.relationship_changed) {
          await this.AddFamilyMember(new_fm);
          changed_somthing = true;
        }
      }
    }
    this.globalService.dismissLoading();
    if (changed_somthing) {
      this.GetFamilyMembers();
    }
  }

  async RemoveFamilyMember(family_member) {
    let data: any = await this.apiService.delete(`clients/family_members/${this.client.guid}`, family_member);
  }
  async AddFamilyMember(family_member) {
    let data: any = await this.apiService.post(`clients/family_members/${this.client.guid}`, family_member);
  }


  // Firm-wide custom field definitions (Manage Firm > Contacts) that this client doesn't already
  // have by name get added here with a blank value - see CustomFieldsService.MergeFieldDefsInto.
  async MergeFirmCustomFields() {
    const defs = await this.customFieldsService.GetFieldDefs();
    this.firmFieldDefs = defs.contacts;
    this.customFieldsService.MergeFieldDefsInto(this.client.custom_data_arr, defs.contacts, defs.loaded, defs.deleted_contacts);
  }
  // Custom tab (view mode): only fields that have a value, unless "Show Empty Custom Fields" is on.
  // Checkbox fields always show, ticked or not.
  show_empty_custom_fields = false;

  VisibleCustomFields(): any[] {
    const fields: any[] = this.client?.custom_data_arr || [];
    if (this.show_empty_custom_fields) return fields;
    return fields.filter((field: any) => {
      if (field?.type === 'checkbox') return true;
      const value = field?.value;
      return value !== null && value !== undefined && !(typeof value === 'string' && value.trim() === '');
    });
  }


  IsGlobalField(field: any): boolean {
    return this.firmFieldDefs?.some(d => d.name === field.name) ?? false;
  }

  async OpenManageGlobalCustomFields() {
    const modal = await this.modalController.create({
      component: ManageCustomFieldsComponent,
      cssClass: 'tall-modal medium-modal secondary-modal',
      backdropDismiss: false,
      componentProps: { entity_type: 'contacts' },
    });
    modal.onDidDismiss().then(async (data: any) => {
      if (data?.data?.saved) await this.MergeFirmCustomFields();
    });
    return await modal.present();
  }

  addField() {
    this.client.custom_data_arr.push({
      name: '',
      type: 'text',
      value: '',
      _is_new: true
    });
  }

  removeField(index: number) {
    this.client.custom_data_arr.splice(index, 1);
  }


  async IsAClientChange() {
    if (!this.client.is_a_client) {
      this.client.active = false;
    }
  }


  CheckIfFormIsValid() {
    const messages: string[] = [];

    // Email required for clients
    if (this.client.email === '' && this.client.is_a_client) {
      messages.push('Email is required for clients.');
    }

    // Email format validation
    if (this.client.email !== '' && !this.globalService.validateEmail(this.client.email)) {
      messages.push('Invalid email format.');
    }

    // Required fields
    if (this.client.display_name === '') {
      messages.push('Display name is required.');
    }

    if (this.client.first_name === '') {
      messages.push('First name is required.');
    }

    if (this.client.last_name === '') {
      messages.push('Last name is required.');
    }

    if (!this.client.all_team_members && this.client.team_members.length == 0) {
      messages.push('At least one team member must be assigned or select "Visible to all team members".');
    }

    // Write to string for tooltip or display
    if (messages.length == 0) return '';
    return messages.join('<br>');
  }



  async DeleteClient() {
    const alert = await this.alertController.create({
      header: 'Delete Contact',
      message: `Are you sure you want to delete <strong>${this.client.display_name}</strong>? This will delete all related projects, tasks, and steps. This action cannot be undone.`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Delete',
          cssClass: 'alert-button-danger',
          handler: async () => {
            await this.globalService.presentLoading('Deleting contact...', 9000000);
            const data: any = await this.apiService.delete(`clients/${this.client.guid}`, {});
            this.globalService.dismissLoading();
            if (data.success) {
              this.globalService.presentToastMessage(data.message, true);
              this.client.deleted = true;
              this.Close();
            } else {
              this.globalService.presentToastMessage(data.message, false);
            }

          }
        }
      ]
    });
    await alert.present();
  }

  async ResetLogin() {
    if (!this.client.active) {
      this.globalService.presentToastMessage("Client must be active to reset login.", false);
      return;
    }
    const alert = await this.alertController.create({
      header: 'Reset Login',
      message: `Are you sure you want to reset the login for ${this.client.display_name}? They will receive an email with their username and a password reset link.`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Reset',
          handler: async () => {
            await this.globalService.presentLoading("Resetting login...", 9000000);
            const data: any = await this.apiService.post(`authentication/reset_password/${this.client.username}`, {});
            if (data.success) {
              this.globalService.presentToastMessage("Login reset successfully. The client will receive an email with instructions to set a new password.", true);
            }
            this.globalService.dismissLoading();
          }
        }
      ]
    });
    await alert.present();

  }



}


